<template>
  <div class="h-full text-gray-800 bg-seastreak-gray-light md:bg-seastreak-gray">
    <OverlayComponent v-if="orderStore.isProcessing" />
    <div class="md:py-4 bg-seastreak-gray-light md:bg-seastreak-gray">
      <div
        class="relative bg-seastreak-gray-light md:max-w-screen-sm md:ml-auto md:mr-auto md:h-auto md:rounded-lg overflow-hidden md:shadow-lg"
      >
        <AppNavbar :left-menu-items="remoteMenuItems" :right-menu-items="TICKETS_MENU_ITEMS" />
        <div class="md:max-w-screen-sm mx-auto p-4">
          <TwcHeading v-if="title" tag="h2" class="mb-2 w-full text-xl font-medium">
            {{ title }}
            <ResponsiveTooltip :content-html="tooltipContent" :title="tooltipTitle" />
          </TwcHeading>
          <ProductComponent />
          <div class="flex mt-3" />
          <TicketBundlingOptions :maximum-tickets="MAX_INDIVIDUAL_TICKETS" />
          <div class="flex mt-4" />
          <TwcParagraph class="mb-0 text-sm font-normal border-slate-400">
            By placing my order, I agree to the
            <TwcButton
              class="text-seastreak-link-blue text-sm font-normal"
              link
              :href="`${settings.terms_of_service_url}`"
              target="_blank"
            >
              Seastreak Terms of Service</TwcButton
            >. Tickets are valid 60 days from date of purchase. Children under 5 years old may board
            for free.
          </TwcParagraph>
          <DividerComponent />
          <BalanceDue />
          <div class="flex mt-5" />
          <PaymentButtons />
          <DividerComponent />
          <TwcParagraph class="mb-0 text-base font-normal border-slate-400">
            Looking for a route map or ferry schedule?
            <TwcButton
              link
              class="text-base font-normal"
              :href="`${settings.ferry_schedule_url}`"
              target="_blank"
            >
              View here</TwcButton
            >
            or call
            <TwcButton
              class="text-base font-normal"
              link
              :href="`tel:${sanitizedContactPhoneNumber}`"
            >
              {{ settings.customer_support_phone }} </TwcButton
            >.
          </TwcParagraph>
        </div>
      </div>
    </div>
  </div>
  <ReloadModal />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { TwcParagraph } from 'transit-web-components'
import AppNavbar from '@/components/AppNavbar.vue'
import ProductComponent from '@/components/ProductComponent.vue'
import TwcButton from '@/components/web-components/TwcButton.vue'
import { TwcHeading } from 'transit-web-components'
import TicketBundlingOptions from '@/components/TicketBundlingOptions.vue'
import BalanceDue from '@/components/BalanceDue.vue'
import PaymentButtons from '@/components/PaymentButtons.vue'
import OverlayComponent from '@/components/OverlayComponent.vue'
import ReloadModal from '@/components/ReloadModal.vue'
import { useOrderStore } from '@/stores/order'
import { useStripeStore } from '@/stores/stripe'
import { useSettingStore } from '@/stores/setting'
import DividerComponent from '@/components/elements/DividerComponent.vue'
import { useNavigationStore } from '@/stores/navigation'
import { TICKETS_MENU_ITEMS, MAX_INDIVIDUAL_TICKETS } from '@/utils/constants'
import ResponsiveTooltip from '@/components/elements/ResponsiveTooltip.vue'

const orderStore = useOrderStore()
const stripeStore = useStripeStore()
const settingStore = useSettingStore()
const navigationStore = useNavigationStore()
const remoteMenuItems = computed(() => navigationStore.remoteMenuItems)
const title = import.meta.env.VITE_ROUTE_TITLE
const { settings } = storeToRefs(settingStore)

const tooltipContent = import.meta.env.VITE_TICKETS_PAGE_TOOLTIP_TRAVEL_ROUTE
const tooltipTitle = import.meta.env.VITE_ROUTE_TITLE

const sanitizedContactPhoneNumber = computed(() => {
  return `+${(settings.value.customer_support_phone || '').replace(/\D/g, '')}`
})

stripeStore.init()
navigationStore.loadRemoteMenuItems()
settingStore.loadSettings()
</script>

<style scoped></style>
